import { render, staticRenderFns } from "./LectureUsersWidget.vue?vue&type=template&id=5a510cbe&scoped=true"
import script from "./LectureUsersWidget.vue?vue&type=script&lang=js"
export * from "./LectureUsersWidget.vue?vue&type=script&lang=js"
import style0 from "./LectureUsersWidget.vue?vue&type=style&index=0&id=5a510cbe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a510cbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a510cbe')) {
      api.createRecord('5a510cbe', component.options)
    } else {
      api.reload('5a510cbe', component.options)
    }
    module.hot.accept("./LectureUsersWidget.vue?vue&type=template&id=5a510cbe&scoped=true", function () {
      api.rerender('5a510cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/LectureUsersWidget.vue"
export default component.exports